function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M28.1407 9.1082L31.3736 8.22654L30.8452 7.47864C30.7968 7.40776 30.7409 7.34661 30.6778 7.2903L28.1407 9.1082Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.54568 4.81919L3.35254 5.27734L7.7881 7.14721L7.98124 6.68905L3.54568 4.81919Z",
  fill: "#2F59A1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.861 4.68467L19.1548 5.95996L19.2477 6.44838L25.9539 5.1731L25.861 4.68467Z",
  fill: "#2F59A1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.9963 5.60064L21.5537 5.82715L22.9106 8.47849L23.3532 8.25198L21.9963 5.60064Z",
  fill: "#2F59A1"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.75248 16.2869L3.30225 18.1211L3.4917 18.5808L7.94194 16.7466L7.75248 16.2869Z",
  fill: "#2F59A1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.205 17.0787L19.1084 17.5664L25.805 18.8935L25.9017 18.4057L19.205 17.0787Z",
  fill: "#2F59A1"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.8865 15.076L21.5093 17.7168L21.9501 17.9467L23.3274 15.3059L22.8865 15.076Z",
  fill: "#2F59A1"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.38897 20.5489C3.15987 20.548 2.97537 20.3621 2.97628 20.133L3.04328 3.23074C3.04419 3.00164 3.23015 2.81714 3.45925 2.81805C3.68835 2.81896 3.87285 3.00492 3.87194 3.23402L3.80494 20.1363C3.80403 20.3654 3.61807 20.5499 3.38897 20.5489Z",
  fill: "#2F59A1"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.8475 20.6378C25.6184 20.6369 25.4339 20.4509 25.4348 20.2218L25.5018 3.3196C25.5027 3.0905 25.6886 2.90601 25.9177 2.90692C26.1468 2.90782 26.3313 3.09379 26.3304 3.32289L26.2634 20.2251C26.2625 20.4542 26.0766 20.6387 25.8475 20.6378Z",
  fill: "#2F59A1"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "car car_dark",
  d: "M24.3397 6.00012C23.4623 5.99665 22.7023 6.49571 22.3265 7.22297L20.7571 6.56112C20.1342 6.3003 19.732 5.68939 19.7347 5.01427L19.7371 4.39765L8.77445 4.3542C7.99941 4.35113 7.36811 4.97744 7.36504 5.75248L7.31791 17.6438C7.31483 18.4188 7.94115 19.0501 8.71619 19.0532L19.6764 19.0966L19.6789 18.48C19.6816 17.8049 20.0886 17.1972 20.7135 16.9413L22.2881 16.2919C22.6581 17.0246 23.4141 17.5272 24.2915 17.5307L28.7712 17.5484L28.8169 6.01787L24.3397 6.00012Z",
  fill: "#2F59A1"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "car",
  d: "M11.1814 4.26331L9.30225 4.25586L9.24318 19.1571L11.1223 19.1646L11.1814 4.26331Z",
  fill: "#75B0FF"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.2851 7.27568L24.9941 7.2666L24.9891 8.5364L27.2801 8.54548L27.2851 7.27568Z",
  fill: "#2F59A1"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.5806 15.8958L25.2896 15.8867L25.2864 16.6886L27.5774 16.6976L27.5806 15.8958Z",
  fill: "#2F59A1"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.5879 14.013L25.2969 14.0039L25.292 15.2274L27.583 15.2365L27.5879 14.013Z",
  fill: "#2F59A1"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.1644 12.6937L21.0691 12.3189L21.0742 11.0199L22.1724 10.6538L22.1644 12.6937Z",
  fill: "#75B0FF"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "car  car_dark",
  d: "M7.34801 16.8519L2.29036 15.0843C1.80358 14.9142 1.47638 14.4522 1.47841 13.938L1.49635 9.41205C1.4984 8.89535 1.82681 8.43845 2.31736 8.27222L7.38643 6.54479L7.34557 16.8519L7.34801 16.8519Z",
  fill: "#2F59A1"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.1298 1.60561L29.1136 5.68066L28.5517 6.01234C27.9654 6.35611 27.6171 6.9153 27.6147 7.51486L27.582 15.782C27.5796 16.3791 27.9235 16.941 28.507 17.2919L29.0662 17.628L29.0497 21.803C29.048 22.2392 29.5757 22.5411 30.0662 22.3822L30.3786 22.2811C31.5597 21.8982 32.341 20.9532 32.3451 19.8979L32.41 3.53674C32.4142 2.48142 31.6429 1.53026 30.4624 1.13806L30.1508 1.03446C29.6616 0.871657 29.1315 1.16934 29.1298 1.60561Z",
  fill: "white"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "car car__front",
  d: "M31.745 3.53343L31.6801 19.8897C31.6771 20.6599 31.0845 21.3497 30.1718 21.6459L29.8594 21.747C29.8375 21.7542 29.8155 21.7566 29.7936 21.7565C29.7595 21.7564 29.7303 21.7489 29.7132 21.7391L29.731 17.2497L28.846 16.7198C28.4666 16.494 28.2414 16.1422 28.2428 15.7815L28.2756 7.51437C28.2768 7.19509 28.456 6.88627 28.7615 6.66082C28.8006 6.63416 28.8422 6.60751 28.8837 6.58087L29.7705 6.06037L29.7729 6.05794L29.7903 1.66848C29.8074 1.66124 29.8367 1.6516 29.8708 1.65174C29.8952 1.65184 29.9171 1.65436 29.939 1.66176L30.2506 1.76536C31.1634 2.06876 31.748 2.76327 31.745 3.53343Z",
  fill: "#75B0FF"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "car",
  d: "M30.3704 14.9103L30.3951 8.66851L22.495 10.1117C22.1219 10.1785 21.875 10.3628 21.8742 10.5675L21.8647 12.9487C21.8639 13.1534 22.1118 13.3372 22.482 13.4093L30.3704 14.9103Z",
  fill: "#75B0FF"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.1746 12.1532L31.1778 11.3368C31.1783 11.2173 31.0446 11.1169 30.8692 11.1089L23.476 10.7384C23.2859 10.7279 23.1222 10.832 23.1217 10.9636L23.1157 12.465C23.1152 12.5966 23.2781 12.702 23.4682 12.693L30.8641 12.3811C31.0397 12.3721 31.1741 12.2727 31.1746 12.1532Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.05602 2.15274L6.04738 4.33163C6.04655 4.54123 5.87527 4.71116 5.66566 4.71033L1.23477 4.69277C1.02516 4.69437 0.855227 4.52309 0.856057 4.31349L0.864704 2.13216C0.865535 1.92256 1.03682 1.75263 1.24642 1.75346L5.67488 1.77101C5.88692 1.77185 6.05685 1.94314 6.05602 2.15274Z",
  fill: "#2F59A1"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.5155 2.24161L28.5069 4.4205C28.506 4.6301 28.3347 4.80003 28.1251 4.7992L23.6942 4.78163C23.4846 4.7808 23.3147 4.60952 23.3155 4.39992L23.3242 2.22103C23.325 2.01143 23.4963 1.8415 23.7059 1.84233L28.1343 1.85988C28.3464 1.86072 28.5163 2.032 28.5155 2.24161Z",
  fill: "#2F59A1"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.98912 19.0551L5.98048 21.234C5.97965 21.4436 5.80837 21.6135 5.59877 21.6127L1.16787 21.5951C0.958272 21.5943 0.788342 21.423 0.789173 21.2134L0.797809 19.0345C0.79864 18.8249 0.969923 18.655 1.17953 18.6558L5.60798 18.6734C5.82002 18.6742 5.98995 18.8455 5.98912 19.0551Z",
  fill: "#2F59A1"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.4481 19.144L28.4395 21.3228C28.4386 21.5324 28.2674 21.7024 28.0578 21.7015L23.6269 21.684C23.4173 21.6831 23.2473 21.5119 23.2482 21.3023L23.2568 19.1234C23.2576 18.9138 23.4289 18.7438 23.6385 18.7447L28.067 18.7622C28.279 18.7631 28.4489 18.9343 28.4481 19.144Z",
  fill: "#2F59A1"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  className: "car car_dark",
  d: "M12.7372 8.49212C12.7372 8.49212 12.7372 8.49212 10.1986 9.45453C9.98866 9.53413 9.79328 9.63328 9.79239 9.85751L9.7781 13.4622C9.77722 13.6864 9.9718 13.7871 10.1811 13.8684C12.712 14.8509 12.712 14.8509 12.712 14.8509L12.7372 8.49212Z",
  fill: "#2F59A1"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  className: "car",
  d: "M7.62879 2.42748L21.7526 2.48346C22.2595 2.48547 22.6698 2.899 22.6678 3.40594L22.6638 4.41252L6.69989 4.34924L6.70388 3.34267C6.70589 2.83572 7.11941 2.42546 7.62879 2.42748Z",
  fill: "#75B0FF"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  className: "car",
  d: "M6.64111 19.043L22.605 19.1062L22.601 20.1128C22.599 20.6198 22.1855 21.03 21.6785 21.028L7.55476 20.972C7.04781 20.97 6.63755 20.5565 6.63956 20.0496L6.64355 19.043L6.64111 19.043Z",
  fill: "#75B0FF"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  className: "car",
  d: "M18.8049 8.53231L16.0728 8.52148L16.0473 14.9436L18.7794 14.9544L18.8049 8.53231Z",
  fill: "#75B0FF"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5044 11.6738C21.5025 12.1491 21.3085 12.531 21.0696 12.53C20.8308 12.5291 20.6397 12.1432 20.6416 11.6704C20.6435 11.1952 20.8376 10.8133 21.0764 10.8142C21.3128 10.8127 21.5063 11.1986 21.5044 11.6738Z",
  fill: "#2F59A1"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.9516 11.4259L20.1895 11.4189L20.1875 11.9161L21.9496 11.9231L21.9516 11.4259Z",
  fill: "#2F59A1"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  className: "car car__engine car_dark",
  d: "M4.43946 9.61985C4.21036 9.61894 4.02587 9.43298 4.02678 9.20388L4.03461 7.22728C4.03868 6.20121 4.87796 5.36855 5.90404 5.37262L8.11218 5.38137C8.34128 5.38228 8.52577 5.56824 8.52486 5.79734C8.52396 6.02644 8.33799 6.21094 8.10889 6.21003L5.90076 6.20128C5.33044 6.19901 4.86553 6.66025 4.86327 7.23057L4.85544 9.20717C4.85453 9.43627 4.66856 9.62076 4.43946 9.61985Z",
  fill: "#4986CC"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  className: "car car__engine car_dark",
  d: "M8.06211 18.024L5.85398 18.0152C4.8279 18.0112 3.99524 17.1719 3.99931 16.1458L4.00715 14.1692C4.00805 13.9401 4.19402 13.7556 4.42312 13.7565C4.65222 13.7574 4.83671 13.9434 4.83581 14.1725L4.82797 16.1491C4.82571 16.7194 5.28695 17.1843 5.85726 17.1866L8.0654 17.1953C8.2945 17.1962 8.479 17.3822 8.47809 17.6113C8.47718 17.8404 8.29121 18.0249 8.06211 18.024Z",
  fill: "#4986CC"
});

var _ref34 =
/*#__PURE__*/
React.createElement("g", {
  className: "engine"
}, React.createElement("path", {
  className: "car car_dark car__engine",
  d: "M6.10046 14.1563L3.16116 14.1447C2.85163 14.1434 2.60159 13.8914 2.60281 13.5819L2.6179 9.77736C2.61912 9.46783 2.87115 9.21779 3.18068 9.21902L6.11999 9.23067C6.42952 9.2319 6.67956 9.48393 6.67833 9.79346L6.66325 13.598C6.65959 13.9075 6.40755 14.1575 6.10046 14.1563Z",
  fill: "#4986CC"
}), React.createElement("path", {
  d: "M6.04559 9.89055C6.04508 10.0173 5.94231 10.1192 5.81558 10.1187L3.48314 10.1095C3.35641 10.109 3.25445 10.0062 3.25495 9.87949C3.25545 9.75275 3.35822 9.6508 3.48496 9.6513L5.81739 9.66054C5.94413 9.66105 6.04609 9.76382 6.04559 9.89055Z",
  fill: "white"
}), React.createElement("path", {
  d: "M6.0407 10.6132C6.0402 10.7399 5.93743 10.8419 5.8107 10.8414L3.47826 10.8322C3.35152 10.8317 3.24957 10.7289 3.25007 10.6021C3.25057 10.4754 3.35334 10.3735 3.48008 10.374L5.81251 10.3832C5.93925 10.3837 6.04121 10.4865 6.0407 10.6132Z",
  fill: "white"
}), React.createElement("path", {
  d: "M6.0368 11.3339C6.0363 11.4606 5.93353 11.5626 5.80679 11.5621L3.47435 11.5529C3.34762 11.5524 3.24566 11.4496 3.24616 11.3229C3.24666 11.1961 3.34943 11.0942 3.47617 11.0947L5.80861 11.1039C5.93534 11.1044 6.0373 11.2072 6.0368 11.3339Z",
  fill: "white"
}), React.createElement("path", {
  d: "M6.03436 12.0546C6.03385 12.1814 5.93108 12.2833 5.80435 12.2828L3.47191 12.2736C3.34518 12.2731 3.24322 12.1703 3.24372 12.0436C3.24422 11.9168 3.34699 11.8149 3.47373 11.8154L5.80616 11.8246C5.9329 11.8251 6.03486 11.9279 6.03436 12.0546Z",
  fill: "white"
}), React.createElement("path", {
  d: "M6.03191 12.7763C6.03141 12.903 5.92864 13.005 5.80191 13.0045L3.46947 12.9952C3.34274 12.9947 3.24078 12.892 3.24128 12.7652C3.24178 12.6385 3.34455 12.5365 3.47129 12.537L5.80372 12.5463C5.93046 12.5468 6.03242 12.6496 6.03191 12.7763Z",
  fill: "white"
}), React.createElement("path", {
  d: "M6.02899 13.498C6.02848 13.6247 5.92571 13.7267 5.79898 13.7262L3.46654 13.7169C3.33981 13.7164 3.23785 13.6136 3.23835 13.4869C3.23885 13.3602 3.34162 13.2582 3.46836 13.2587L5.80079 13.268C5.92753 13.2685 6.02949 13.3712 6.02899 13.498Z",
  fill: "white"
}));

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  className: "car",
  d: "M18.397 6.61276L10.454 6.58128C10.2249 6.58037 10.0404 6.39441 10.0413 6.16531C10.0422 5.93621 10.2282 5.75171 10.4573 5.75262L18.4003 5.7841C18.6294 5.78501 18.8138 5.97098 18.8129 6.20008C18.812 6.42918 18.6261 6.61367 18.397 6.61276Z",
  fill: "#75B0FF"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  className: "car",
  d: "M18.353 17.7007L10.4101 17.6692C10.181 17.6683 9.99647 17.4823 9.99738 17.2532C9.99829 17.0241 10.1843 16.8396 10.4134 16.8405L18.3563 16.872C18.5854 16.8729 18.7699 17.0589 18.769 17.288C18.7681 17.5171 18.5821 17.7016 18.353 17.7007Z",
  fill: "#75B0FF"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M22.8756 7.75453C22.8937 7.50113 23.1162 7.30946 23.3385 7.18604C23.8563 6.9005 24.4611 6.8249 25.0535 6.78338C25.212 6.77182 25.3729 6.76271 25.5313 6.75603C25.6971 6.74937 25.8653 6.74516 26.0284 6.77993C26.2938 6.83704 26.5345 6.99885 26.6871 7.22613C26.8374 7.45095 26.8972 7.73635 26.8474 8.00425C26.8125 8.19178 26.7094 8.38392 26.5287 8.44901C26.458 8.4731 26.3824 8.47768 26.3093 8.48226C26.0484 8.49585 25.7803 8.50697 25.527 8.44748C25.3639 8.40783 25.2057 8.33896 25.0375 8.34561C24.8523 8.35219 24.6862 8.44658 24.5201 8.52879C24.1831 8.69563 23.7708 8.81098 23.4376 8.63418C23.2697 8.54577 23.146 8.39417 23.0419 8.23533C22.9449 8.09115 22.8627 7.92753 22.8756 7.75453Z",
  fill: "#4986CC"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M22.845 15.6662C22.8611 15.9197 23.0821 16.1132 23.3034 16.2383C23.819 16.528 24.4231 16.6084 25.0152 16.6546C25.1735 16.6674 25.3344 16.6778 25.4927 16.6857C25.6585 16.6937 25.8266 16.6992 25.99 16.6682C26.2559 16.6132 26.4978 16.4533 26.6523 16.2272C26.8043 16.0036 26.8663 15.7187 26.8186 15.4504C26.7853 15.2626 26.6837 15.0697 26.5036 15.0031C26.433 14.9785 26.3575 14.9733 26.2844 14.9681C26.0236 14.9525 25.7556 14.9392 25.5019 14.9967C25.3384 15.0351 25.1797 15.1027 25.0116 15.0947C24.8264 15.0867 24.661 14.991 24.4956 14.9074C24.16 14.7379 23.7485 14.6193 23.4139 14.7935C23.2454 14.8805 23.1205 15.0312 23.0151 15.1892C22.917 15.3326 22.8335 15.4955 22.845 15.6662Z",
  fill: "#4986CC"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M20.8481 6.97214L23.5082 6.73165C24.8097 6.7368 25.052 8.924 23.718 9.13807L21.058 9.37856C20.3997 9.43445 19.8191 8.94957 19.7632 8.29128L19.7609 8.2669C19.705 7.60861 20.1899 7.02803 20.8481 6.97214Z",
  fill: "#4986CC"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M20.8113 16.4352L23.4693 16.6967C24.7708 16.7019 25.0305 14.5167 23.6982 14.2921L21.0402 14.0305C20.3823 13.9694 19.7979 14.4496 19.7368 15.1075L19.7343 15.1318C19.6732 15.7897 20.1534 16.3741 20.8113 16.4352Z",
  fill: "#4986CC"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M21.1209 9.35858L15.884 11L15.1276 8.14544L20.6282 6.99491C21.2746 6.85855 21.9091 7.2754 22.043 7.92181L22.0478 7.9462C22.1842 8.59018 21.7697 9.22467 21.1209 9.35858Z",
  fill: "#4986CC"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M21.1023 14.0478L15.8761 12.3673L15.0971 15.2158L20.5884 16.4099C21.2337 16.549 21.8715 16.1396 22.0105 15.4943L22.0155 15.4699C22.1594 14.827 21.75 14.1893 21.1023 14.0478Z",
  fill: "#4986CC"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  className: "car car_dark",
  d: "M19.5961 11.6972C19.602 10.2129 20.2401 9.09919 21.081 9.10252C21.9218 9.10586 22.5511 10.2271 22.5452 11.7089C22.5393 13.1907 21.9012 14.3069 21.0604 14.3036C20.2195 14.3027 19.5903 13.1815 19.5961 11.6972ZM21.719 11.7056C21.7233 10.6064 21.3068 9.92966 21.0777 9.92875C20.8486 9.92784 20.4267 10.5989 20.4224 11.7005C20.418 12.7997 20.8345 13.4765 21.0636 13.4774C21.2927 13.4783 21.7146 12.8073 21.719 11.7056Z",
  fill: "#2F59A1"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M11.1584 10.0039C11.1587 9.92346 11.1663 9.8455 11.1788 9.76999C11.2562 9.30722 11.5526 8.9233 11.9556 8.72261L11.9629 8.7202L12.0386 8.68638L12.0508 8.68155C12.2192 8.61154 12.4046 8.57328 12.5996 8.57405L17.1913 8.59225L17.1668 14.7828L12.5751 14.7646C12.3825 14.7639 12.195 14.7241 12.0271 14.6528L12.0174 14.6503L11.942 14.6159L11.9347 14.6134C11.5333 14.4071 11.2375 14.0208 11.1662 13.5599C11.1543 13.4843 11.1473 13.4063 11.1476 13.3259L11.1608 10.0039L11.1584 10.0039Z",
  fill: "#4986CC"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.7809 9.40777C19.7373 9.32961 19.6987 9.24171 19.7258 9.15651C19.748 9.09323 19.8043 9.04958 19.858 9.00836C19.9436 8.9429 20.034 8.88232 20.1172 8.81441C20.5622 8.45302 21.1829 8.66265 21.3312 8.73392C21.4334 8.78307 21.5356 8.83222 21.6378 8.88381C21.7205 8.92313 21.8056 8.96734 21.8589 9.04067C21.9559 9.1751 21.977 9.38235 21.9349 9.54305C21.7602 9.34737 21.5074 9.19039 21.2906 9.14322C21.1835 9.11842 21.0981 9.14977 21.0125 9.22011C20.966 9.25648 20.9414 9.31244 20.9266 9.36844C20.8722 9.57052 21.0028 9.81964 21.1582 9.95918C21.2502 10.1107 20.9811 10.3826 20.7504 10.1477C20.6873 10.0816 20.5029 9.8859 20.4202 9.84658C20.0164 9.64999 19.9067 9.63737 19.7809 9.40777Z",
  fill: "white"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.7627 13.9915C19.7186 14.0693 19.6792 14.1569 19.7057 14.2423C19.7274 14.3057 19.7833 14.3498 19.8367 14.3915C19.9218 14.4576 20.0117 14.5189 20.0943 14.5875C20.5364 14.9524 21.1587 14.7477 21.3077 14.6776C21.4103 14.6293 21.5128 14.5809 21.6154 14.5301C21.6984 14.4915 21.7839 14.4479 21.8378 14.375C21.9358 14.2414 21.9586 14.0343 21.9178 13.8733C21.7415 14.0676 21.4874 14.2225 21.2703 14.268C21.163 14.2919 21.0778 14.2599 20.9928 14.1889C20.9466 14.1522 20.9225 14.096 20.9081 14.0399C20.8553 13.8374 20.9879 13.5893 21.1444 13.451C21.2376 13.3003 20.9706 13.0262 20.7381 13.2593C20.6745 13.3248 20.4885 13.5191 20.4055 13.5578C20.0001 13.7487 19.8904 13.7629 19.7627 13.9915Z",
  fill: "white"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M20.6055 8.61652C20.1371 8.74628 19.9237 9.0769 19.8513 9.51045L18.1123 9.20133L16.3076 8.87977L12.9326 10.553L11.1785 9.77098C11.2558 9.30821 11.5523 8.92429 11.9552 8.7236L11.9625 8.72119L12.0382 8.68737L12.0504 8.68254L15.6371 7.08816C15.8398 6.99878 16.0713 6.98995 16.2806 7.0639L20.6055 8.61652Z",
  fill: "#4986CC"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M20.5806 14.7894C20.1131 14.6559 19.9024 14.3236 19.8335 13.8895L18.0921 14.1848L16.2848 14.492L12.9233 12.7921L11.1629 13.5602C11.2367 14.0236 11.53 14.4098 11.9314 14.6137L11.9387 14.6162L12.0141 14.6506L12.0263 14.6555L15.6002 16.2783C15.8021 16.3693 16.0336 16.3799 16.2435 16.3076L20.5806 14.7894Z",
  fill: "#4986CC"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  className: "player",
  d: "M15.482 11.6838C15.4789 12.4467 15.2206 13.0452 14.8143 13.4774C14.7385 13.5576 14.6553 13.6352 14.5673 13.7007C14.0392 14.1251 13.3388 14.3344 12.615 14.3315C11.3842 14.3266 10.3492 13.4841 10.0515 12.3447C10.0035 12.1642 9.97499 11.9764 9.96845 11.7838C9.96617 11.7424 9.96634 11.7009 9.9665 11.6595C9.96683 11.5766 9.9696 11.4938 9.97966 11.4134C9.99749 11.2209 10.0372 11.0334 10.094 10.8557C10.4395 9.77981 11.4491 9.00388 12.6385 9.0086C13.2868 9.01117 13.9198 9.18672 14.4205 9.5348C14.5129 9.5961 14.5979 9.66468 14.6805 9.74056C14.9549 9.99025 15.1755 10.3031 15.3153 10.6814C15.4214 10.9743 15.4834 11.3109 15.482 11.6838Z",
  fill: "#75B0FF"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.4821 11.6829C15.479 12.4457 15.2207 13.0443 14.8144 13.4765C14.7386 13.5566 14.6554 13.6343 14.5674 13.6998C14.327 13.477 14.287 13.1064 14.4831 12.8342C14.7037 12.5231 14.8173 12.1336 14.8191 11.6778C14.8212 11.1636 14.6815 10.734 14.4026 10.4015C14.1891 10.1472 14.2003 9.77429 14.4206 9.53388C14.513 9.59518 14.598 9.66376 14.6806 9.73964C15.1712 10.1827 15.4854 10.8299 15.4821 11.6829Z",
  fill: "white"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  className: "player player_dark",
  d: "M15.674 11.6837C15.6694 12.834 15.259 13.0859 14.8138 13.4765C14.6778 13.3712 14.6493 13.1736 14.7522 13.0303C15.0145 12.6608 15.1479 12.208 15.15 11.6816C15.1523 11.0893 14.9862 10.5866 14.6563 10.1905C14.5447 10.056 14.5577 9.85859 14.6824 9.73966C15.1706 10.1827 15.6784 10.5625 15.674 11.6837Z",
  fill: "#2F59A1"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.8608 11.8016L14.8586 12.3622L10.0523 12.3431C10.0043 12.1626 9.97579 11.9748 9.96924 11.7822L14.8608 11.8016Z",
  fill: "white"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.8632 10.8729L14.861 11.431L9.97679 11.4116C9.99462 11.2192 10.0344 11.0317 10.0911 10.854L14.8632 10.8729Z",
  fill: "white"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.6083 9.2142L28.6343 6.51278L29.7704 6.0211L30.6083 9.2142Z",
  fill: "white"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.5897 14.1756L28.5943 16.8612L29.7264 17.3619L30.5897 14.1756Z",
  fill: "white"
});

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.2dd48b0d.svg";
export { ForwardRef as ReactComponent };